import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Densiĝis krepusko.
    </p>
    
    <p class="mb-3">
      La kapoj sin klinis unu al la alia, la interparoloj fariĝis pli obtuzaj. 
      Sed des pli arde brilis en malluma ĉambro nesatigebla brulanta malamo.
    </p>
    
    <p class="mb-3">
      - Oni devas mortigi lin. 
      Li ne devas vivi. 
      Li ne rajtas vivi. 
      Ne regu nin la persono, kiu ĉiuflanke superas nin.
    </p>
    
    <p class="mb-3">
      - Jes, tio vere neelteneblas. 
      Ĉiutage, ĉiuminute konscii, ke li reale estas supera: scias pli multe, pli rapide pensas, pli sukcese solvas la problemojn, kaj ĉiuj liaj solvoj estas ĝustaj! 
      Ili gvidas al la venkoj, sed tiuj venkoj estas LIAJ!
    </p>
    
    <p class="mb-3">
      - Kaj ni ne povas kundividi ilin! Ni ne farus, ne kondutus tiel, kiel li, kaj do ne povas senti nin venkintoj, kvankam ni servas al li. Li ne estas nia, kaj ni ne estas kun li. 
      Liaj venkoj ne estas niaj venkoj.
    </p>
    
    <p class="mb-3">
      - Li konstante humiligas min per la tuta sia vivo mem. 
      Kial li sukcesas en ĉio? Kial oni amas lin, sed min ne? 
      Li eĉ malamikojn pardonas, kaj ili transiras al lia flanko. 
      Sed miaj malamikoj ja malamas min!
    </p>
    
    <p class="mb-3">
      - Jes, jes! Ĝuste tion mi neniam pardonos al li. 
      Mi scipovas batali, mi konas la malamon al la malamiko, kaj tiu malamo gvidas min en batalo. 
      Mi neniam kompatis iun, kaj oni ne kompatis min. 
      Sed li – pardonas! 
      Kaj venkas pli ofte, ol mi! 
      Mi ne toleros tion! 
    </p>
    
    <p class="mb-3">
      - Kaj mi lin malamas pro tio, ke li povas pli multe, ol ordinaraj homoj en ordinara vivo. 
      Kian rajton li havas esti supera? Rompi ĉiujn regulojn, stari super la amaso? 
      Li povas samtempe legi, paroli kaj skribi, sed normala homo ne! 
      Tio ne estas juste!
    </p>
    
    <p class="mb-3">
      - Ankaŭ mi ne povas legi kaj paroli simultane. 
      Kial li povas? 
      Mi ne volas, ke ekzistu iu, kiu estu pli saĝa, pli lerta, pli prudenta, ol mi; ke iu povu kaj scipovu pli multe! 
      Kaj se tia homo ekzistas – li ne ekzistu plu! Ne ekzistu iu pli dotita, pli perfekta, ol mi!
    </p>
    
    <p class="mb-3">
      - Jes, vi ĉiuj pravas. 
      La plej neeltenebla afero estas toleri la regadon de persono, kiu regas nin laŭmerite, laŭ siaj realaj avantaĝoj, kaj ni eĉ ne povas kontentigi nin per la kliŝoj kiel «Eĉ la Suno havas makulojn» kaj «Ajna homo estas neglektinda humila vermo». 
      Jes, ni ĉiuj estas senbrilaj kaj senpovaj, sed ni multas! 
      Ni povas ataki lin ĉiuj kune, kaj li mortu! 
    </p>

    <p class="mb-3">
      (Ĉiuj kune): Li mortu! 
    </p>
    
    <p class="mb-3">
      Densiĝis krepusko.
    </p>

    <p class="mb-3">
      Estis vespero de la 14a de marto de 44a jaro a.K.
    </p>
    `
  )
}

const itemName = {
  esp: 'Printempaj revoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;